const baseState = {
    number: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
    userPaginationParamsSetted: false
}

const paginationReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_ALL_PAGINATION_PARAMS": {
			return {
				...state,
				number: payload.number,
			    size: payload.size,
			    totalElements: payload.totalElements,
			    totalPages: payload.totalPages
			}
		}

    	case "SET_PAGE_NUMBER": {
			return {
				...state,
				number: payload
			}
		}

		case "SET_PAGE_SIZE": {
			return {
				...state,
				size: payload
			}
		}

		case "SET_TOTAL_ELEMENTS": {
			return {
				...state,
				totalElements: payload
			}
		}

		case "SET_TOTAL_PAGES": {
			return {
				...state,
				totalPages: payload
			}
		}

        default:
            return state;
    }
}

export default paginationReducer